export type Certificate = {
  id: string
  studentId: string
  courseId: string
  dateStarted: Date
  dateIssued: Date
}

export const certificates: Certificate[] = [
  {
    id: 'cert-0',
    studentId: 'student-0',
    courseId: 'm1js',
    dateStarted: new Date('2020/02/03'),
    dateIssued: new Date('2022/02/03')
  },
  {
    id: 'cert-1',
    studentId: 'student-0',
    courseId: 'fcdm',
    dateStarted: new Date('2020/02/03'),
    dateIssued: new Date('2022/06/28')
  },
  {
    id: 'cert-2',
    studentId: 'student-0',
    courseId: 'cafed',
    dateStarted: new Date('2020/02/03'),
    dateIssued: new Date('2022/02/03')
  },
  {
    id: 'cert-3',
    studentId: 'student-0',
    courseId: 'cabed',
    dateStarted: new Date('2020/02/03'),
    dateIssued: new Date('2022/06/28')
  }
]
